import type { Traducao } from '../tipos';

/** IA de dentro da apreciação: gerar partes, encaixar fotos, proveniência. */
export const apreciacaoIa: Traducao = {
  pt: {
    confianca: {
      alta: 'alta',
      media: 'média',
      baixa: 'baixa',
      ausente: 'não encontrado',
    },
    origemCampo: {
      meta: {
        maquinaId: 'vínculo da pasta',
        apreciacao: 'apreciação vinculada',
      },
      cronogramaTarefa: 'cronograma',
      ativo: {
        sismana: 'Curva S (SISMANA)',
        tag: 'Curva S (TAG)',
        nomeExato: 'Curva S',
        nomeFuzzy: 'Curva S (por semelhança)',
      },
      maquina: {
        nome: 'cadastro de máquinas',
      },
      historicoArea: 'histórico da área',
      constante: 'padrão do sistema',
      usuario: 'você',
      inferido: 'inferido',
      ausente: '—',
    },
    confirmar: {
      titulo: 'Criar apreciação com IA',
      carregando: 'Resolvendo contexto da pasta…',
      intro: 'A IA vai analisar <strong>{{fotos}} foto(s)</strong>{{cache}} e criar uma apreciação em <strong>rascunho</strong>. Confira os dados abaixo — eles definem a identidade do documento.',
      introCache: ' ({{quantidade}} já analisadas antes, serão reaproveitadas)',
      rotulo: {
        maquina: 'Máquina',
        tagSismana: 'TAG / SISMANA',
        local: 'Local (C.1.2)',
        responsavel: 'Responsável (C.2)',
        partes: 'Partes',
      },
      maquina: {
        confirmarCadastro: 'Confirmar a máquina no cadastro (Curva S):',
        nenhuma: 'Nenhuma — criar máquina nova com o nome da pasta',
        semelhanca: ' (semelhança {{score}})',
      },
      tipo: {
        naoInformado: 'não informado',
      },
      identificacao: {
        vazio: 'sem TAG nem SISMANA — C.1.1 ficará vazio e a placa não será gerada',
      },
      entrevistado: {
        deixarEmBranco: 'Deixar em branco',
        opcao: '{{nome}} — {{cargo}} ({{ocorrencias}}x na {{escopo}})',
        escopo: {
          local: 'mesma linha',
          area: 'area',
          projeto: 'projeto',
        },
        semHistorico: 'sem histórico de entrevistas nesta área',
      },
      partes: {
        usarModelo: 'Usar o modelo <strong>{{nome}}</strong> ({{total}} partes)',
        desmarcar: 'Desmarque para a IA definir as partes a partir das fotos.',
        semModelo: 'Nenhum modelo compatível — as partes serão definidas pela IA.',
      },
      aviso: {
        titulo: 'Atenção',
        jaTemApreciacao: 'Esta pasta já tem apreciação vinculada. Será criada uma <strong>nova</strong>, sem alterar as existentes.',
        poucasFotos: 'Poucas fotos ({{total}}) — o resultado pode ficar incompleto.',
      },
      rodape: 'A apreciação será criada como rascunho, com todas as partes marcadas como não revisadas. Nada é enviado ao cliente automaticamente.',
      acao: {
        gerar: 'Gerar apreciação',
        semFotos: 'A pasta não tem fotos para analisar',
      },
      erro: {
        resolverContexto: 'Não foi possível resolver o contexto desta pasta',
        carregarContexto: 'Erro ao carregar contexto',
        iniciar: 'Não foi possível iniciar a geração',
        iniciarInesperado: 'Erro ao iniciar a geração',
      },
    },
    progresso: {
      titulo: 'Gerando apreciação com IA',
      percentual: '{{valor}}%',
      falhouEm: 'Falhou em "{{etapa}}":',
      interrompido: 'O servidor reiniciou durante a execução. É possível retomar do último ponto salvo.',
      avisos: '{{total}} aviso(s)',
      podeFechar: 'Você pode fechar esta janela e continuar trabalhando — a geração continua no servidor.',
      cancelar: 'Cancelar geração',
      cancelarTitulo: 'A etapa em andamento pode terminar antes de parar',
      retomar: 'Retomar',
      rascunhoParcial: 'Rascunho parcial mantido',
      abrirApreciacao: 'Abrir apreciação',
    },
    etapa: {
      resolverContexto: 'Resolvendo contexto (cronograma, ativo, área)',
      criarApreciacao: 'Criando a apreciação',
      autofillCabecalho: 'Preenchendo cabeçalho, C.1 a C.4',
      carregarFotos: 'Carregando fotos da pasta',
      descreverImagens: 'Analisando fotos',
      selecionarDestaque: 'Escolhendo foto panorâmica e de identificação',
      decidirPartes: 'Definindo as partes da apreciação',
      detalharPartes: 'Detalhando cada parte',
      persistirRiscos: 'Gravando os riscos',
      finalizar: 'Finalizando',
      concluido: 'Concluído',
    },
    banner: {
      titulo: 'Criada com auxílio de IA',
      em: ' em {{data}}',
      baixaConfianca: '{{total}} campo(s) de baixa confiança',
      ajustesHrn: '{{total}} ajuste(s) de HRN',
      revise: 'revise antes de liberar',
      confiraCampos: 'Confira estes campos',
      avisosTitulo: 'Avisos da geração',
      ajustesTitulo: 'Ajustes de HRN ({{total}})',
      origemTitulo: 'Origem de cada campo ({{total}})',
      origem: {
        constante: 'Padrão do sistema',
        banco: 'Banco de dados',
        planilha: 'Curva S',
        ia: 'IA',
        usuario: 'Você',
        derivado: 'Derivado',
      },
      campo: {
        titulo: 'Título',
        emitente: 'Emitente',
        demanda: 'Demanda',
        descricao: 'Descrição (topo)',
        nomeMaquina: 'Máquina',
        tipoMaquina: 'Tipo',
        identificacaoMaquina: 'C.1.1 TAG',
        setorMaquina: 'Local (cabeçalho)',
        tensaoAcionamento: 'C.1.8 Tensão de alimentação',
        tensaoComando: 'C.1.9 Tensão de comando',
        operadorEntrevistado: 'C.2.1 Responsável',
        cargoOperador: 'C.2.2 Função',
        dataEntrevista: 'C.2.4 Data da entrevista',
        limitesUso: 'C.3.1 Limites de uso',
        limitesEspaco: 'C.3.2 Limites de espaço',
        limitesAdicionais: 'C.3.3 Limites de tempo',
        historicoAcidentes: 'C.3.4 Histórico de acidentes',
        listaVerificacaoAdministrativa: 'C.4 Lista de verificação',
        executanteExterno: 'Executante',
        elaboradorExterno: 'Elaborador',
        verificadorExterno: 'Verificador',
        responsavelTecnicoExterno: 'Responsável técnico',
        maquina: {
          nome: 'Nome da máquina',
          tipo: 'Tipo da máquina',
          local: 'C.1.2 Localização',
          area: 'C.2.3 Área',
          site: 'C.2.5 Empresa',
          descricao: 'C.1.7 Descrição da máquina',
          fabricante: 'C.1.3 Fabricante',
          modelo: 'C.1.4 Modelo',
          serie: 'C.1.5 Número de série',
          ano: 'C.1.6 Ano de fabricação',
        },
      },
    },
  },
  en: {
    confianca: {
      alta: 'high',
      media: 'medium',
      baixa: 'low',
      ausente: 'not found',
    },
    origemCampo: {
      meta: {
        maquinaId: 'folder link',
        apreciacao: 'linked assessment',
      },
      cronogramaTarefa: 'schedule',
      ativo: {
        sismana: 'Curva S (SISMANA)',
        tag: 'Curva S (TAG)',
        nomeExato: 'Curva S',
        nomeFuzzy: 'Curva S (by similarity)',
      },
      maquina: {
        nome: 'machine registry',
      },
      historicoArea: 'area history',
      constante: 'system default',
      usuario: 'you',
      inferido: 'inferred',
      ausente: '—',
    },
    confirmar: {
      titulo: 'Create Risk Assessment with AI',
      carregando: 'Resolving the folder context…',
      intro: 'The AI will analyze <strong>{{fotos}} photo(s)</strong>{{cache}} and create a <strong>draft</strong> assessment. Check the data below — it defines the identity of the document.',
      introCache: ' ({{quantidade}} already analyzed before, will be reused)',
      rotulo: {
        maquina: 'Machine',
        tagSismana: 'TAG / SISMANA',
        local: 'Location (C.1.2)',
        responsavel: 'Person in charge (C.2)',
        partes: 'Machine parts',
      },
      maquina: {
        confirmarCadastro: 'Confirm the machine in the registry (Curva S):',
        nenhuma: 'None — create a new machine with the folder name',
        semelhanca: ' (similarity {{score}})',
      },
      tipo: {
        naoInformado: 'not informed',
      },
      identificacao: {
        vazio: 'no TAG and no SISMANA — C.1.1 will be left empty and the nameplate will not be generated',
      },
      entrevistado: {
        deixarEmBranco: 'Leave blank',
        opcao: '{{nome}} — {{cargo}} ({{ocorrencias}}x in the {{escopo}})',
        escopo: {
          local: 'same line',
          area: 'area',
          projeto: 'project',
        },
        semHistorico: 'no interview history in this area',
      },
      partes: {
        usarModelo: 'Use the <strong>{{nome}}</strong> template ({{total}} parts)',
        desmarcar: 'Uncheck to let the AI define the machine parts from the photos.',
        semModelo: 'No compatible template — the machine parts will be defined by the AI.',
      },
      aviso: {
        titulo: 'Attention',
        jaTemApreciacao: 'This folder already has a linked assessment. A <strong>new</strong> one will be created, leaving the existing ones untouched.',
        poucasFotos: 'Few photos ({{total}}) — the result may be incomplete.',
      },
      rodape: 'The assessment will be created as a draft, with every machine part marked as not reviewed. Nothing is sent to the customer automatically.',
      acao: {
        gerar: 'Generate assessment',
        semFotos: 'The folder has no photos to analyze',
      },
      erro: {
        resolverContexto: 'Could not resolve the context of this folder',
        carregarContexto: 'Error loading the context',
        iniciar: 'Could not start the generation',
        iniciarInesperado: 'Error starting the generation',
      },
    },
    progresso: {
      titulo: 'Generating Risk Assessment with AI',
      percentual: '{{valor}}%',
      falhouEm: 'Failed at "{{etapa}}":',
      interrompido: 'The server restarted during the run. It can be resumed from the last saved point.',
      avisos: '{{total}} warning(s)',
      podeFechar: 'You can close this window and keep working — the generation continues on the server.',
      cancelar: 'Cancel generation',
      cancelarTitulo: 'The step in progress may finish before it stops',
      retomar: 'Resume',
      rascunhoParcial: 'Partial draft kept',
      abrirApreciacao: 'Open assessment',
    },
    etapa: {
      resolverContexto: 'Resolving context (schedule, asset, area)',
      criarApreciacao: 'Creating the assessment',
      autofillCabecalho: 'Filling in the header, C.1 to C.4',
      carregarFotos: 'Loading the photos from the folder',
      descreverImagens: 'Analyzing photos',
      selecionarDestaque: 'Choosing the overview and identification photos',
      decidirPartes: 'Defining the machine parts of the assessment',
      detalharPartes: 'Detailing each machine part',
      persistirRiscos: 'Saving the hazards',
      finalizar: 'Finishing',
      concluido: 'Done',
    },
    banner: {
      titulo: 'Created with AI assistance',
      em: ' on {{data}}',
      baixaConfianca: '{{total}} low-confidence field(s)',
      ajustesHrn: '{{total}} HRN adjustment(s)',
      revise: 'review before releasing',
      confiraCampos: 'Check these fields',
      avisosTitulo: 'Generation warnings',
      ajustesTitulo: 'HRN adjustments ({{total}})',
      origemTitulo: 'Source of each field ({{total}})',
      origem: {
        constante: 'System default',
        banco: 'Database',
        planilha: 'Curva S',
        ia: 'AI',
        usuario: 'You',
        derivado: 'Derived',
      },
      campo: {
        titulo: 'Title',
        emitente: 'Issuer',
        demanda: 'Request',
        descricao: 'Description (top)',
        nomeMaquina: 'Machine',
        tipoMaquina: 'Type',
        identificacaoMaquina: 'C.1.1 TAG',
        setorMaquina: 'Location (header)',
        tensaoAcionamento: 'C.1.8 Supply voltage',
        tensaoComando: 'C.1.9 Control voltage',
        operadorEntrevistado: 'C.2.1 Person in charge',
        cargoOperador: 'C.2.2 Role',
        dataEntrevista: 'C.2.4 Interview date',
        limitesUso: 'C.3.1 Use limits',
        limitesEspaco: 'C.3.2 Space limits',
        limitesAdicionais: 'C.3.3 Time limits',
        historicoAcidentes: 'C.3.4 Accident history',
        listaVerificacaoAdministrativa: 'C.4 Checklist',
        executanteExterno: 'Performed by',
        elaboradorExterno: 'Prepared by',
        verificadorExterno: 'Checked by',
        responsavelTecnicoExterno: 'Technical manager',
        maquina: {
          nome: 'Machine name',
          tipo: 'Machine type',
          local: 'C.1.2 Location',
          area: 'C.2.3 Area',
          site: 'C.2.5 Company',
          descricao: 'C.1.7 Machine description',
          fabricante: 'C.1.3 Manufacturer',
          modelo: 'C.1.4 Model',
          serie: 'C.1.5 Serial number',
          ano: 'C.1.6 Year of manufacture',
        },
      },
    },
  },
};
